(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/betslip/assets/javascripts/views/parts/pay-button-external.js') >= 0) return;  svs.modules.push('/components/tipsen/betslip/assets/javascripts/views/parts/pay-button-external.js');
"use strict";

const {
  useContext
} = React;
const {
  PayButtonView
} = svs.components.tipsen.betslip.views.parts;
const {
  format
} = svs.utils;
const {
  PaymentContext
} = svs.components.tipsen.couponId;
const {
  useIsAtBottomWindow
} = svs.components.tipsen.hooks;
const {
  useSelector
} = ReactRedux;
const {
  BetslipContext
} = svs.components.tipsen.betslip;
const {
  useIsCurrentDrawPlayable
} = svs.components.tipsen.hooks;
const {
  selectActiveWallet
} = svs.components.tipsen.walletSelectors;
const {
  selectPrice
} = svs.components.tipsen.engine.selectors.couponSelectors;
const PayButtonExternal = () => {
  const isAtBottom = useIsAtBottomWindow();
  const {
    couponId
  } = useContext(BetslipContext);
  const isDrawPlayable = useIsCurrentDrawPlayable();
  const isLoggedIn = !svs.core.userSession.isAnonymous();
  const activeWallet = useSelector(selectActiveWallet);
  const price = useSelector(state => selectPrice(state, couponId));
  const placeBet = useContext(PaymentContext);
  const isDisabled = () => {
    if (!isDrawPlayable) {
      return true;
    }
    if (isLoggedIn) {
      return !activeWallet;
    }
    return false;
  };
  const handlePay = async () => {
    if (isAtBottom) {
      placeBet();
    } else {
      window.scrollTo({
        left: 0,
        top: document.body.scrollHeight,
        behavior: 'smooth'
      });
    }
  };
  const betslipLabel = isAtBottom ? "Betala ".concat(format.Currency(price), " kr") : "".concat(format.Currency(price), " kr");
  return React.createElement("div", {
    className: "pay-button"
  }, React.createElement(PayButtonView, {
    betslipLabel: betslipLabel,
    handlePay: handlePay,
    hasScrollBehavior: !isAtBottom,
    isDisabled: isDisabled(),
    isFocused: isAtBottom,
    priceProp: price
  }));
};
setGlobal('svs.components.tipsen.betslip.views.parts.PayButtonExternal', PayButtonExternal);

 })(window);